import React, { createContext, useContext, useState, useEffect } from 'react';

const ProgressContext = createContext();

export const useProgress = () => {
  const context = useContext(ProgressContext);
  if (!context) {
    throw new Error('useProgress must be used within ProgressProvider');
  }
  return context;
};

export const ProgressProvider = ({ children }) => {
  const [completedTopics, setCompletedTopics] = useState(() => {
    const saved = localStorage.getItem('completedTopics');
    return saved ? JSON.parse(saved) : [];
  });

  useEffect(() => {
    localStorage.setItem('completedTopics', JSON.stringify(completedTopics));
  }, [completedTopics]);

  const markTopicComplete = (topicId) => {
    if (!completedTopics.includes(topicId)) {
      setCompletedTopics([...completedTopics, topicId]);
    }
  };

  const markTopicIncomplete = (topicId) => {
    setCompletedTopics(completedTopics.filter(id => id !== topicId));
  };

  const isTopicComplete = (topicId) => {
    return completedTopics.includes(topicId);
  };

  const getSubjectProgress = (subjectTopics) => {
    const completed = subjectTopics.filter(topic => 
      completedTopics.includes(topic._id)
    ).length;
    return {
      completed,
      total: subjectTopics.length,
      percentage: subjectTopics.length > 0 
        ? Math.round((completed / subjectTopics.length) * 100) 
        : 0
    };
  };

  const resetProgress = () => {
    setCompletedTopics([]);
  };

  return (
    <ProgressContext.Provider value={{
      completedTopics,
      markTopicComplete,
      markTopicIncomplete,
      isTopicComplete,
      getSubjectProgress,
      resetProgress
    }}>
      {children}
    </ProgressContext.Provider>
  );
};
